<template>
  <div>
    <md-empty-state
      v-if="emptyConfig"
      md-description="Não há configurações para este equipamento."
      md-icon="warning"
    />

    <div v-else class="md-layout">
      <div
        v-for="value in filteredConfigs"
        :key="value.id"
        class="md-layout-item md-gutter md-small-size-50 md-size-33 mb-2"
      >
        <ConfiguracaoGeralEquipamentoCard
          :value="value"
          @click="(e) => (tipoEnvio = e.configName)"
        />
      </div>
    </div>

    <md-dialog-confirm
      :md-active="showDialog"
      md-content="O sistema irá enviar a configuração. Deseja continuar?"
      md-confirm-text="Enviar"
      md-cancel-text="Cancelar"
      @md-confirm="handleEnviar"
      @md-cancel="tipoEnvio = null"
    />

    <md-dialog :md-active.sync="loading">
      <div class="p-5" style="text-align: center">
        <md-progress-spinner
          :md-diameter="100"
          :md-stroke="10"
          md-mode="indeterminate"
        />
      </div>
    </md-dialog>
  </div>
</template>

<script>
import ConfiguracaoGeralEquipamentoCard from '@/components/equipamento/card/ConfiguracaoGeralEquipamentoCard.vue'
import { SkippedConfiguracaoGeralEquipamento } from '@/utils/constants'
import http from '@/utils/http'

export default {
  name: 'AcompanhamentoConfiguracaoGeral',
  components: { ConfiguracaoGeralEquipamentoCard },
  props: {
    config: Array,
    equipamentoId: String,
  },
  data() {
    return {
      tipoEnvio: null,
      loading: false,
    }
  },
  computed: {
    filteredConfigs() {
      return this.config.filter(
        (e) => SkippedConfiguracaoGeralEquipamento.has(e.configName) === false
      )
    },
    showDialog() {
      return !!this.tipoEnvio
    },
    emptyConfig() {
      return this.config.length === 0
    },
  },
  methods: {
    async handleEnviar() {
      this.loading = true

      try {
        const temp = this.tipoEnvio
        this.tipoEnvio = null

        await http.post(
          `/equipamento/calibracao/${this.equipamentoId}/configuracao/enviar`,
          {
            configuracao: temp,
          }
        )
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
